import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/LP202407/AWSFargate'

const AWSFargate: React.FC = () => {
  return (
    <>
      <CustomHead
        keyword={'AWS Fargate サーバーレス コンテナ 自動スケーリング'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/services/awsfargate/'}
        title="AWS Fargate | サービス | Aitria（アイトリア）"
        description="AWS Fargate導入支援で、サーバーレスなコンテナ環境を提供します。自動スケーリングにより、迅速なデプロイと効率的なリソース管理を実現します。"
      />
      <Template />
    </>
  )
}

export default AWSFargate
